<template>
  <div class="cw-dropped-file">
    <div class="name">{{ this.file.name }}</div>

    <progress class="progress" v-if="this.fileUploadStarted(this.file.id)" :value="this.getFileProgress(this.file.id)" max="100">{{ this.getFileProgress(this.file.id) }}% </progress>

  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator';
import useFilesStore, { UploadableFile } from '@/store/files';

@Component({
  emits: ["exit"],
  components: {},
})
export default class TickFileUploadProgress extends Vue {
  @Prop() private file!: UploadableFile;

  private fileUploadStarted(fileId) {
    const file = this.getUploadFile(fileId);
    return file ? file.uploadStarted : false;
  }

  private getFileProgress(fileId) {
    const file = this.getUploadFile(fileId);
    return file ? file.percentageUploaded : 0;
  }

  private getUploadFile(fileId) {
    const file = useFilesStore().getFileUpload(fileId);
    return file;
  }

}
</script>

<style lang="scss" scoped>
@import "@/styles/theme";

.cw-dropped-file {
  border: solid 1px $grey400;
  border-radius: 4px;

  display: grid;
  gap: 5px;
  padding: 2px 4px;

  font-size: 14px;

  grid-template-columns: 1fr auto auto;
  grid-template-rows: auto;
  grid-template-areas: "name progress actions";

  align-items: center;

  .name {
    grid-area: name;
  }

  .progress {
    grid-area: progress;
    accent-color: $success;

  }

  .actions {
    grid-area: actions;

    .delete {
      float: right;

    }
  }

}
</style>
